// components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()

  // Still resolving auth state — render nothing to avoid flash
  if (loading) return null

  // Not logged in — redirect to login
  if (!user) return <Navigate to="/login" replace />

  return children
}